export default __webpack_public_path__ + "static/cruiselines-carnival-ship-2-710b453d1a6718a209a0207cf0c049d2.jpg";